import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../../services/user-service/user.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (UserService.isUserLoggedIn()) {
      return true; // Allow access if user is logged in
    } else {
      this.router.navigate(['/user/login'],{ queryParams: { returnUrl: state.url } }); // Redirect to login if not authenticated
      return false;
    }
  }
}